let baseURL = 'https://servdev2.admisi.uin-suka.ac.id/api/'
let base = 'https://servdev2.admisi.uin-suka.ac.id/'

// if (process.env.NODE_ENV === 'stage') {
//   baseURL = 'https://dev.service.admisi.uin-suka.ac.id/api/'
//   base = 'https://dev.service.admisi.uin-suka.ac.id/'
// }

// if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
//   baseURL = 'https://servdev2.admisi.uin-suka.ac.id/api/'
//   base = 'https://servdev2.admisi.uin-suka.ac.id/'
// }

export { baseURL, base }



// WEBPACK FOOTER //
// ./src/api/data.js